import * as React from 'react';
var ResizeContext = React.createContext(null);
export default ResizeContext;